import styled from 'styled-components'

export const DrawerHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  position: sticky;
  top: 0;
  padding-bottom: 24px;
  border-bottom: 1px solid #efefef;
  background: white;
  z-index: 1;
  .title {
    flex: 1;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .close-button {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: none;
    &:hover {
      background: var(--blackAlpha-100, rgba(0, 0, 0, 0.06));
    }

    .close-icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
  }
`
